export const ID = '5847d0c0-8e0f-4d9c-9918-301457641250';

export const NAME = 'Amenities: Facility - Advanced';
